/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DashboardCreateFromTemplateRequest,
  DashboardRepresentation,
  DashboardTemplateRepresentation,
  DashboardTemplateUpdateRequest,
  PortfolioCreateFromTemplateRequest,
  PortfolioRepresentation,
  PortfolioTemplateRepresentation,
  TemplateCreateFromDashboardRequest,
  TemplateCreateFromPortfolioRequest,
  TemplateCreateFromWidgetRequest,
  WidgetCreateRequest,
  WidgetTemplateRepresentation,
} from '../models/index';
import {
    DashboardCreateFromTemplateRequestFromJSON,
    DashboardCreateFromTemplateRequestToJSON,
    DashboardRepresentationFromJSON,
    DashboardRepresentationToJSON,
    DashboardTemplateRepresentationFromJSON,
    DashboardTemplateRepresentationToJSON,
    DashboardTemplateUpdateRequestFromJSON,
    DashboardTemplateUpdateRequestToJSON,
    PortfolioCreateFromTemplateRequestFromJSON,
    PortfolioCreateFromTemplateRequestToJSON,
    PortfolioRepresentationFromJSON,
    PortfolioRepresentationToJSON,
    PortfolioTemplateRepresentationFromJSON,
    PortfolioTemplateRepresentationToJSON,
    TemplateCreateFromDashboardRequestFromJSON,
    TemplateCreateFromDashboardRequestToJSON,
    TemplateCreateFromPortfolioRequestFromJSON,
    TemplateCreateFromPortfolioRequestToJSON,
    TemplateCreateFromWidgetRequestFromJSON,
    TemplateCreateFromWidgetRequestToJSON,
    WidgetCreateRequestFromJSON,
    WidgetCreateRequestToJSON,
    WidgetTemplateRepresentationFromJSON,
    WidgetTemplateRepresentationToJSON,
} from '../models/index';

export interface CreateDashboardFromTemplateRequest {
    key: string;
    dashboardCreateFromTemplateRequest: DashboardCreateFromTemplateRequest;
}

export interface CreatePortfolioFromTemplateRequest {
    key: string;
    portfolioCreateFromTemplateRequest: PortfolioCreateFromTemplateRequest;
}

export interface CreateTemplateFromDashboardRequest {
    templateCreateFromDashboardRequest: TemplateCreateFromDashboardRequest;
}

export interface CreateTemplateFromPortfolioRequest {
    templateCreateFromPortfolioRequest: TemplateCreateFromPortfolioRequest;
}

export interface CreateTemplateFromWidgetRequest {
    templateCreateFromWidgetRequest: TemplateCreateFromWidgetRequest;
}

export interface GetWidgetStubFromTemplateRequest {
    key: string;
}

export interface RemoveDashboardTemplateRequest {
    key: string;
}

export interface RemoveWidgetTemplateRequest {
    key: string;
}

export interface UpdateDashboardTemplateRequest {
    key: string;
    dashboardTemplateUpdateRequest: DashboardTemplateUpdateRequest;
}

/**
 * 
 */
export class TemplatesApi extends runtime.BaseAPI {

    /**
     * Create a new dashboard from given template
     * Create dashboard from template
     */
    async createDashboardFromTemplateRaw(requestParameters: CreateDashboardFromTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling createDashboardFromTemplate().'
            );
        }

        if (requestParameters['dashboardCreateFromTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'dashboardCreateFromTemplateRequest',
                'Required parameter "dashboardCreateFromTemplateRequest" was null or undefined when calling createDashboardFromTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/dashboards/{key}/instances`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DashboardCreateFromTemplateRequestToJSON(requestParameters['dashboardCreateFromTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new dashboard from given template
     * Create dashboard from template
     */
    async createDashboardFromTemplate(key: string, dashboardCreateFromTemplateRequest: DashboardCreateFromTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardRepresentation> {
        const response = await this.createDashboardFromTemplateRaw({ key: key, dashboardCreateFromTemplateRequest: dashboardCreateFromTemplateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new portfolio instance from a template
     * Create portfolio from template
     */
    async createPortfolioFromTemplateRaw(requestParameters: CreatePortfolioFromTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling createPortfolioFromTemplate().'
            );
        }

        if (requestParameters['portfolioCreateFromTemplateRequest'] == null) {
            throw new runtime.RequiredError(
                'portfolioCreateFromTemplateRequest',
                'Required parameter "portfolioCreateFromTemplateRequest" was null or undefined when calling createPortfolioFromTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios/by-key/{key}/instances`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PortfolioCreateFromTemplateRequestToJSON(requestParameters['portfolioCreateFromTemplateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new portfolio instance from a template
     * Create portfolio from template
     */
    async createPortfolioFromTemplate(key: string, portfolioCreateFromTemplateRequest: PortfolioCreateFromTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioRepresentation> {
        const response = await this.createPortfolioFromTemplateRaw({ key: key, portfolioCreateFromTemplateRequest: portfolioCreateFromTemplateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a new template from existing dashboard
     * Create template from dashboard
     */
    async createTemplateFromDashboardRaw(requestParameters: CreateTemplateFromDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardTemplateRepresentation>> {
        if (requestParameters['templateCreateFromDashboardRequest'] == null) {
            throw new runtime.RequiredError(
                'templateCreateFromDashboardRequest',
                'Required parameter "templateCreateFromDashboardRequest" was null or undefined when calling createTemplateFromDashboard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/dashboards`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TemplateCreateFromDashboardRequestToJSON(requestParameters['templateCreateFromDashboardRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardTemplateRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new template from existing dashboard
     * Create template from dashboard
     */
    async createTemplateFromDashboard(templateCreateFromDashboardRequest: TemplateCreateFromDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardTemplateRepresentation> {
        const response = await this.createTemplateFromDashboardRaw({ templateCreateFromDashboardRequest: templateCreateFromDashboardRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a portfolio template from a source portfolio
     * Create portfolio template
     */
    async createTemplateFromPortfolioRaw(requestParameters: CreateTemplateFromPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PortfolioTemplateRepresentation>> {
        if (requestParameters['templateCreateFromPortfolioRequest'] == null) {
            throw new runtime.RequiredError(
                'templateCreateFromPortfolioRequest',
                'Required parameter "templateCreateFromPortfolioRequest" was null or undefined when calling createTemplateFromPortfolio().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["portfolios:write"]);
        }


        let urlPath = `/portfolios/templates`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TemplateCreateFromPortfolioRequestToJSON(requestParameters['templateCreateFromPortfolioRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PortfolioTemplateRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a portfolio template from a source portfolio
     * Create portfolio template
     */
    async createTemplateFromPortfolio(templateCreateFromPortfolioRequest: TemplateCreateFromPortfolioRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PortfolioTemplateRepresentation> {
        const response = await this.createTemplateFromPortfolioRaw({ templateCreateFromPortfolioRequest: templateCreateFromPortfolioRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Create a widget template from a widget
     * Create widget template
     */
    async createTemplateFromWidgetRaw(requestParameters: CreateTemplateFromWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetTemplateRepresentation>> {
        if (requestParameters['templateCreateFromWidgetRequest'] == null) {
            throw new runtime.RequiredError(
                'templateCreateFromWidgetRequest',
                'Required parameter "templateCreateFromWidgetRequest" was null or undefined when calling createTemplateFromWidget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/widgets`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TemplateCreateFromWidgetRequestToJSON(requestParameters['templateCreateFromWidgetRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetTemplateRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a widget template from a widget
     * Create widget template
     */
    async createTemplateFromWidget(templateCreateFromWidgetRequest: TemplateCreateFromWidgetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetTemplateRepresentation> {
        const response = await this.createTemplateFromWidgetRaw({ templateCreateFromWidgetRequest: templateCreateFromWidgetRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Return all available dashboard templates for current user
     * Get dashboard templates
     */
    async getAllDashboardTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DashboardTemplateRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/template/dashboards`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DashboardTemplateRepresentationFromJSON));
    }

    /**
     * Return all available dashboard templates for current user
     * Get dashboard templates
     */
    async getAllDashboardTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DashboardTemplateRepresentation>> {
        const response = await this.getAllDashboardTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all widget templates the user has access to
     * Get widget templates
     */
    async getAllWidgetTemplatesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WidgetTemplateRepresentation>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:read"]);
        }


        let urlPath = `/template/widgets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WidgetTemplateRepresentationFromJSON));
    }

    /**
     * Get all widget templates the user has access to
     * Get widget templates
     */
    async getAllWidgetTemplates(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WidgetTemplateRepresentation>> {
        const response = await this.getAllWidgetTemplatesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a temporary widget stub from a template
     * Get widget stub
     */
    async getWidgetStubFromTemplateRaw(requestParameters: GetWidgetStubFromTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WidgetCreateRequest>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getWidgetStubFromTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/widgets/{key}/instances`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WidgetCreateRequestFromJSON(jsonValue));
    }

    /**
     * Get a temporary widget stub from a template
     * Get widget stub
     */
    async getWidgetStubFromTemplate(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WidgetCreateRequest> {
        const response = await this.getWidgetStubFromTemplateRaw({ key: key }, initOverrides);
        return await response.value();
    }

    /**
     * Delete a dashboard template
     * Delete dashboard template
     */
    async removeDashboardTemplateRaw(requestParameters: RemoveDashboardTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling removeDashboardTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/dashboards/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a dashboard template
     * Delete dashboard template
     */
    async removeDashboardTemplate(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeDashboardTemplateRaw({ key: key }, initOverrides);
    }

    /**
     * Delete widget template
     * Delete widget template
     */
    async removeWidgetTemplateRaw(requestParameters: RemoveWidgetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling removeWidgetTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/widgets/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete widget template
     * Delete widget template
     */
    async removeWidgetTemplate(key: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeWidgetTemplateRaw({ key: key }, initOverrides);
    }

    /**
     * Update a dashboard template
     * Update dashboard template
     */
    async updateDashboardTemplateRaw(requestParameters: UpdateDashboardTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardTemplateRepresentation>> {
        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling updateDashboardTemplate().'
            );
        }

        if (requestParameters['dashboardTemplateUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'dashboardTemplateUpdateRequest',
                'Required parameter "dashboardTemplateUpdateRequest" was null or undefined when calling updateDashboardTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["dashboards:write"]);
        }


        let urlPath = `/template/dashboards/{key}`;
        urlPath = urlPath.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters['key'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DashboardTemplateUpdateRequestToJSON(requestParameters['dashboardTemplateUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardTemplateRepresentationFromJSON(jsonValue));
    }

    /**
     * Update a dashboard template
     * Update dashboard template
     */
    async updateDashboardTemplate(key: string, dashboardTemplateUpdateRequest: DashboardTemplateUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardTemplateRepresentation> {
        const response = await this.updateDashboardTemplateRaw({ key: key, dashboardTemplateUpdateRequest: dashboardTemplateUpdateRequest }, initOverrides);
        return await response.value();
    }

}
